/** @format */

import React, { Component, Fragment } from 'react';
import styled from 'src/ui/library/styled';
import PropTypes from 'prop-types';
import Button from 'src/ui/library/Button';
import { saveAPIFile } from 'src/helpers';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
const styles = theme => ({
  root: {
    maxWidth: '180px !important',
  },
});

class FileDownloadBase extends Component {
  static propTypes = {
    /** Classname to be applied to FileDownloadButton */
    className: PropTypes.string,
    /** If `true`, downloadButton will be Disabled */
    isDisabled: PropTypes.bool,
    /** It will show label for the fileDownloadButton */
    label: PropTypes.string,
    /** It will show label for the fileDownloadButton */
    buttonLabel: PropTypes.string,
    /** Callback function that triggers on button `onClick`. onRequest(setFileData: fn, setFileName: fn, setStatus: fn) */
    onRequest: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
    isDisabled: false,
    label: '',
  };

  state = {
    fileName: '',
    fileData: '',
    status: false,
  };

  handleOnRequest = () => {
    if (this.props.onRequest) {
      this.props.onRequest(this.setFileData.bind(this), this.setStatus.bind(this));
    }
  };

  setFileData = (fileData, fileName) => {
    this.setState({ fileData: fileData, fileName: fileName, status: true }, () => {
      saveAPIFile(this.state.fileData, this.state.fileName);
      this.setState({ status: false, fileData: '', fileName: '' });
    });
  };

  setStatus = status => {
    this.setState({ status: status });
  };

  render() {
    const { isDisabled, buttonLabel, fileExtension, label, href, showSpinner, onRequest, ...otherProps } = this.props;

    return (
      <Fragment>
        {showSpinner === true && <ServiceSpinner downlaodSpinner={showSpinner} open={true} />}
        {label ? <p>{label}</p> : ''}
        <Button
          disabled={isDisabled || showSpinner}
          isLoading={this.state.status}
          styleType={'tertiary'}
          onClick={this.handleOnRequest}
          href={href}
          {...otherProps}>
          <span>{buttonLabel}</span>
        </Button>
      </Fragment>
    );
  }
}

export { FileDownloadBase };
export default styled(FileDownloadBase)(styles);
